export type LanguageType = {
  id: string;
  orderIndex: number;
};

export const LANGUAGES: LanguageType[] = [
  {
    id: 'EN',
    orderIndex: 1,
  },
  {
    id: 'FR',
    orderIndex: 2,
  },
  {
    id: 'DE',
    orderIndex: 3,
  },
  {
    id: 'LU',
    orderIndex: 4,
  },
];

export const ORDERED_LANGUAGES = LANGUAGES.sort((a, b) => a.orderIndex - b.orderIndex);
